import {Parameter, ToolboxOptionsOptions} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalBackgroundToolboxOptions} from "./PortalBackgroundToolboxOptions";
import {PortalHeaderFooterToolboxOptions} from "./PortalHeaderFooterToolboxOptions";
import {PortalBoxesToolboxOptions} from "./PortalBoxesToolboxOptions";
import {PortalPageTransitionsToolboxOptions} from "./PortalPageTransitionsToolboxOptions";

export class PortalToolboxOptionsOptions extends ToolboxOptionsOptions implements Parameter {
	constructor(data: any) {
		super(data);

		this.background = PortalBackgroundToolboxOptions.fromJson(data?.background);
		this.headerFooter = PortalHeaderFooterToolboxOptions.fromJson(data?.headerFooter);
		this.boxes = PortalBoxesToolboxOptions.fromJson(data?.boxes);
		this.pageTransitions = PortalPageTransitionsToolboxOptions.fromJson(data?.pageTransitions);
	}

	public static fromJson(data: any): PortalToolboxOptionsOptions {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalToolboxOptionsOptions(data);
	}

	public clone(): PortalToolboxOptionsOptions {
		return PortalToolboxOptionsOptions.fromJson(this.toJson());
	}
}